import * as z from 'zod'
import { RelationshipsReportPayload } from '~bank-reports/types/RelationshipsReport'

export const relationshipsReportSchema = z.object({
  search: z.string().optional().nullable(),
  inApplicationProcessOnly: z.boolean().default(false),
  page: z.number().int().positive().default(1),
  size: z.number().int().positive().default(10)
}) as z.ZodType<Omit<RelationshipsReportPayload, 'id'>>
